import React, { Fragment } from 'react';

import classNames from 'classnames';
import { useRouteMatch } from 'react-router-dom';

import NestedLink from 'components/NestedLink';
import Typography from 'components/Typography';

import { Tag } from 'graphql/generated/graphql';

import { useAuth } from 'hooks/useAuth';

interface IProps {
  className?: string;
  tags: ReadonlyArray<Pick<Tag, 'id' | 'name'>>;
  tagToExclude?: Pick<Tag, 'id' | 'name'> | null;
  onTagClick?: (tagId: string) => void;
}

const TagPillList = ({ className, tags, tagToExclude, onTagClick }: IProps) => {
  const {
    params: { section = '' },
  } = useRouteMatch<{ section?: string }>();

  const filteredTags = tags.filter((tag) => tag.id !== tagToExclude?.id);

  const { isAuthenticated } = useAuth();
  const renderItem = (tag, index) => {
    if (isAuthenticated) {
      return (
        <NestedLink
          className="tag inline-block rounded-2xl border border-solid border-light-body text-white mr-1 no-underline py-1 px-2"
          key={`${tag.id}-${index}`}
          to={`${section || 'browse'}/tag/${tag.id}`}
          onClick={(e) => {
            onTagClick?.(tag.id);
          }}
        >
          <Typography variant="body">{tag.name}</Typography>
        </NestedLink>
      );
    }
    return (
      <Fragment key={`${tag.id}-${index}`}>
        <Typography
          className="inline-block rounded-2xl border border-solid border-light-body text-white mr-1 py-1 px-2"
          variant="body"
        >
          {tag.name}
        </Typography>
      </Fragment>
    );
  };

  return (
    <div
      className={classNames(
        'TagPillList mt-4 py-4 px-0 whitespace-nowrap overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden',
        className,
      )}
      data-testid="TagPillListTest"
    >
      {filteredTags.map((tag, index) => renderItem(tag, index))}
    </div>
  );
};

export default TagPillList;
